/* eslint no-underscore-dangle: 0 */
import { compose, applyMiddleware, createStore } from "redux";
import Immutable from "immutable";
import thunkMiddleware from "redux-thunk";
import root from "./rootReducer";

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(
        {
          // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
        }
      )
    : compose;
const enhancer = composeEnhancers(
  applyMiddleware(thunkMiddleware)
  // other store enhancers if any
);

const initialState = Immutable.Map();
const store = createStore(root, initialState, enhancer);

export default store;



// WEBPACK FOOTER //
// ./src/store.js